export const environment = {
  apiUrl: 'https://api.iraniexpert.com/api/',
  contentUrl: 'https://dl.iraniexpert.com/',
  production: true,
};
